(() => {
  const normalise = (value) => { const text = String(value || '').toLowerCase(); if (text.includes('rose')) return 'rose'; if (text.includes('white') || text.includes('silver')) return 'white'; if (text.includes('yellow')) return 'yellow'; return text; };
  const controllers = new WeakMap();

  function initialise(gallery) {
    if (controllers.has(gallery)) return;
    const section = gallery.closest('[data-section-type="product"]');
    const slides = Array.from(gallery.querySelectorAll('[data-image-id]'));
    const position = Number(gallery.dataset.ilColourPosition);
    const list = gallery.querySelector('[data-product-media-list]');
    if (!section || !list || !slides.length) return;
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb-item]'));
    const zoom = gallery.querySelector('zoom-images');
    const zoomImages = Array.from(zoom?.querySelectorAll('[data-zoom-image]') || []);
    const thumbTemplate = gallery.querySelector('[data-pswp-thumbs-template]');
    const zoomThumbs = Array.from(thumbTemplate?.content.children || []).map((node) => node.cloneNode(true));
    let colour;
    let visible = slides;

    function pause(slide) {
      slide.querySelectorAll('video').forEach((video) => video.pause());
      slide.querySelectorAll('iframe').forEach((frame) => {
        const url = new URL(frame.src, location.href);
        if (url.hostname.endsWith('youtube.com') || url.hostname.endsWith('youtube-nocookie.com')) {
          frame.contentWindow?.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo', args: []}), url.origin);
        } else if (url.hostname === 'player.vimeo.com') {
          frame.contentWindow?.postMessage(JSON.stringify({method: 'pause'}), url.origin);
        }
      });
      slide.querySelector('model-viewer')?.pause?.();
    }

    function updateThumbs(id) {
      thumbs.forEach((thumb) => {
        const link = thumb.querySelector('[data-thumb-link]');
        const active = link?.dataset.mediaId === id;
        thumb.classList.toggle('is-active', active);
        link?.setAttribute('aria-current', String(active));
      });
    }

    function updateSpecifications(value, variant) {
        const options = variant?.options || Array.from(section.querySelectorAll('[data-option-position]')).map((wrapper) => wrapper.querySelector('input:checked, input[type="hidden"][data-single-option-selector], select')?.value);
        const finish = options[position - 1] || value;
        if (!finish) return;
        const material = options.find((option) => /^(925 Silver|14k Gold) \+ /.test(option));
        const metal = material?.startsWith('925 Silver') ? '925 Silver' : `14k ${finish}`;
        section.querySelectorAll('[data-il-spec-metal]').forEach((node) => { node.textContent = metal; });
        section.querySelectorAll('[data-il-spec-stones]').forEach((node) => {
          node.textContent = material?.includes('Natural') ? 'Natural Diamonds' : 'Lab-Grown Diamonds';
        });
    }

    function apply(value, variant) {
      updateSpecifications(value, variant);
      const next = normalise(value);
      if (!next || next === colour) return;
      colour = next;
      const matching = slides.filter((slide) => slide.dataset.ilColour === colour);
      visible = slides.filter((slide) => slide.dataset.ilColour === colour || slide.dataset.ilColour === 'all');
      if (!visible.length) visible = slides;
      const featured = matching.find((slide) => slide.dataset.imageId === String(variant?.featured_media?.id));
      const hero = featured || matching[0] || visible[0];
      visible = [hero, ...visible.filter((slide) => slide !== hero && slide.dataset.ilColour === colour), ...visible.filter((slide) => slide !== hero && slide.dataset.ilColour !== colour)];
      const ordered = [...visible, ...slides.filter((slide) => !visible.includes(slide))];
      ordered.forEach((slide, index) => {
        const current = list.children[index];
        if (current !== slide) {
          if (list.moveBefore) list.moveBefore(slide, current || null);
          else list.insertBefore(slide, current || null);
        }
      });
      slides.forEach((slide) => {
        const hidden = !visible.includes(slide);
        pause(slide);
        slide.toggleAttribute('data-il-colour-hidden', hidden);
        slide.inert = hidden;
        slide.classList.remove('media--hiding');
        slide.classList.toggle('media--active', slide === hero);
        slide.classList.toggle('media--hidden', slide !== hero);
      });
      const thumbList = thumbs[0]?.parentElement;
      const orderedThumbs = ordered.map((slide) => thumbs.find((thumb) => thumb.querySelector('[data-media-id]')?.dataset.mediaId === slide.dataset.mediaId)).filter(Boolean);
      orderedThumbs.forEach((thumb, index) => {
        const current = thumbList.children[index];
        if (current !== thumb) {
          if (thumbList.moveBefore) thumbList.moveBefore(thumb, current || null);
          else thumbList.insertBefore(thumb, current || null);
        }
      });
      thumbs.forEach((thumb) => {
        const id = thumb.querySelector('[data-media-id]')?.dataset.mediaId;
        const hidden = !visible.some((slide) => slide.dataset.mediaId === id);
        thumb.toggleAttribute('data-il-colour-hidden', hidden);
        thumb.inert = hidden;
      });
      gallery.productMediaItems = visible;
      gallery.dataset.activeMedia = hero.dataset.mediaId;
      gallery.dataset.ilSelectedColour = colour;
      gallery.dataset.ilMissingColour = String(!matching.length);
      hero.querySelector('img')?.setAttribute('loading', 'eager');
      updateThumbs(hero.dataset.mediaId);
      thumbList?.scrollTo({left: 0, top: 0, behavior: 'instant'});
      list.scrollTo({left: 0, top: 0, behavior: 'instant'});
      gallery.setHeight();
      requestAnimationFrame(() => gallery.setHeight());
    }

    const nativeSetActive = gallery.setActiveMedia.bind(gallery);
    gallery.setActiveMedia = (id) => {
      const target = visible.find((slide) => slide.dataset.mediaId === id);
      if (!target) return;
      slides.filter((slide) => slide !== target).forEach(pause);
      nativeSetActive(id);
      updateThumbs(id);
    };
    const neighbour = (direction) => {
      const index = visible.findIndex((slide) => slide.classList.contains('media--active'));
      return visible[(Math.max(index, 0) + direction + visible.length) % visible.length]?.dataset.mediaId;
    };
    gallery.getNextMediaId = () => neighbour(1);
    gallery.getPreviousMediaId = () => neighbour(-1);

    if (zoom) {
      const nativeCreateZoom = zoom.createZoom.bind(zoom);
      zoom.createZoom = (originalIndex) => {
        const selected = zoomImages[originalIndex];
        const filtered = visible.map((slide) => slide.querySelector('[data-zoom-image]')).filter(Boolean);
        const index = filtered.indexOf(selected);
        if (index < 0) return;
        zoom.images = filtered;
        if (thumbTemplate && zoomThumbs.length === zoomImages.length) {
          thumbTemplate.content.replaceChildren(...filtered.map((image) => zoomThumbs[zoomImages.indexOf(image)].cloneNode(true)));
        }
        nativeCreateZoom(index);
      };
    }

    section.querySelectorAll('product-form').forEach((form) => {
      form.updateProductImage = () => {};
    });
    const selectedColour = () => {
      const wrapper = section.querySelector(`[data-option-position="${position}"]`);
      return wrapper?.querySelector('input:checked, input[type="hidden"][data-single-option-selector], select')?.value;
    };
    section.addEventListener('theme:variant:change', (event) => {
      const variant = event.detail?.variant;
      apply(variant?.options?.[position - 1] || selectedColour(), variant);
    });
    section.addEventListener('change', (event) => {
      updateSpecifications(selectedColour());
      if (event.target.closest(`[data-option-position="${position}"]`)) apply(selectedColour());
    }, true);
    const product = section.querySelector('[data-product-json]');
    const variants = product ? JSON.parse(product.textContent).variants : [];
    const initial = variants.find((variant) => String(variant.id) === gallery.dataset.ilInitialVariant);
    apply(selectedColour() || gallery.dataset.ilInitialColour, initial);
    controllers.set(gallery, {apply, selectedColour});
  }

  function scan(root = document) {
    root.querySelectorAll('[data-il-colour-gallery]').forEach(initialise);
  }
  Promise.all(['product-images', 'zoom-images', 'product-form'].map((name) => customElements.whenDefined(name))).then(() => {
    scan();
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    window.addEventListener('pageshow', () => scan());
    let previousVariant = new URL(location.href).searchParams.get('variant');
    document.addEventListener('theme:variant:change', () => {
      queueMicrotask(() => { previousVariant = new URL(location.href).searchParams.get('variant'); });
    });
    window.addEventListener('popstate', () => {
      const current = new URL(location.href).searchParams.get('variant');
      if (document.querySelector('[data-il-colour-gallery]') && current !== previousVariant) location.reload();
    });
  });
})();

